import React from 'react';

import ReferentAppointments from '../../components/Communication/ReferentAppointments/ReferentAppointments.module';

function ReferentAppointmentsView() {
  return (
    <ReferentAppointments />
  );
}

export default ReferentAppointmentsView;


